import "vant/es/button/style";
import _Button from "vant/es/button";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d8fde552"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "before-wrap"
};
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = {
  class: "before-footer"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "before-mask"
  }, null, -1);
});
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
export default {
  __name: 'index',
  emits: ['close', 'confirm'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var store = useStore();
    var content = computed(function () {
      var _store$getters;
      return ((_store$getters = store.getters) === null || _store$getters === void 0 || (_store$getters = _store$getters.getQuesInfo) === null || _store$getters === void 0 ? void 0 : _store$getters.popupContent) || '';
    });
    function handleBtnClick(isAgree) {
      if (isAgree) {
        emit('confirm');
      } else {
        emit('close');
      }
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", {
        class: "content-wrap",
        innerHTML: content.value
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(_Button), {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return handleBtnClick(false);
        }),
        class: "footer-btn"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("不同意")];
        }),
        _: 1
      }), _createVNode(_unref(_Button), {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return handleBtnClick(true);
        }),
        class: "footer-btn confirm-btn"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("同意")];
        }),
        _: 1
      })])]), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_hoisted_4]))], 64);
    };
  }
};